import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TakeAStand from './pages/TakeAStand';
import { Toaster } from './components/ui/toaster';
import { Toaster as SonnerToaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    document.title = 'Take A Stand \u2014 ACCI | African Caribbean Community Initiative';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TakeAStand />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <SonnerToaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
